import Service from "../../AuthService";
const ProductOverview = {
    getProductOverview(page,data) {
        return Service.get("/overview-product?page="+page+
            '&start_date='+data.start_date+
            '&end_date='+data.end_date +
            '&month='+data.month +
            '&product_sku='+data.product_sku +
            '&product_type_id='+data.product_type_id +
            '&type='+data.type
        );
    },
    getProductOverviewPerSale(data) {
        return Service.get("/overview-product-per-sale?"+
            '&start_date='+data.start_date+
            '&end_date='+data.end_date +
            '&month='+data.month +
            '&product_sku='+data.product_sku +
            '&product_type_id='+data.product_type_id +
            '&sale_id='+data.sale_id
        );
    },
};
export default ProductOverview;
